import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

interface IProps {
  isActive: boolean;
  children?: ReactNode;
  onClick?: () => void;
  to?: string;
  isCategory?: boolean;
  className?: string;
}

const Tab: FC<IProps> = ({ isActive, children, onClick, to = '#', isCategory = false, className }: IProps) => {
  return (
    <TabWrapper className={className}>
      <StyledTabItem
        isActive={isActive || false}
        isCategory={isCategory}
      >
        <Link
          to={to}
          onClick={onClick}
        >
          {children}
        </Link>
      </StyledTabItem>
    </TabWrapper>
  );
};

export default Tab;

const TabWrapper = styled.div`
  display: flex;
  margin-right: 2rem;
  padding-bottom: 2px;

  @media ${props => props.theme.breakpoints.md} {
    margin-right: 0;
  }
`;

const StyledTabItem = styled.span<{ isActive: boolean; isCategory: boolean }>`
  padding: ${props => (props.isCategory ? '0.5rem' : '0.75rem')} 0;
  border-bottom: ${props => (props.isActive ? `3px solid ${props.theme.colors.primary}` : 'none')};
  margin-bottom: ${props => (props.isActive ? '-3px' : 0)};
  color: ${props => (props.isActive ? props.theme.colors.primary : props.theme.colors.dark)};

  & > a {
    font-size: ${props => (props.isCategory ? '0.875rem' : '1rem')};
    text-decoration: none;
    color: inherit;
  }

  &:hover {
    text-decoration: none;
    color: ${props => props.theme.colors.primary};
    border-bottom: 3px solid ${props => props.theme.colors.primary};
    margin-bottom: -3px;
  }

  @media ${props => props.theme.breakpoints.md} {
    flex: 0 0 100%;
    border-bottom: none;
    position: relative;
    margin-bottom: 0;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #dee2e6;
    }

    &:hover {
      color: ${props => props.theme.colors.primary};
      border-bottom: none;
      margin-bottom: 0;
    }
  }
`;
